export default __webpack_public_path__ + "static/media/877.1ed31b14.png";